import { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function DataGrid({ data }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 20,
      },
      {
        accessor: "userFullName",
        Header: "نام مشتری",
        minWidth: "100px",
        Cell: ({ row }) => (
          <div className={!row.original.havePayToWaranty ? "text-danger" : ""}>{row.original.userFullName}</div>
        ),
      },
      {
        accessor: "phoneNumber",
        Header: "موبایل",
        minWidth: "100px",
        Cell: ({ row }) => (
          <div className={!row.original.havePayToWaranty ? "text-danger" : ""}>{row.original.phoneNumber}</div>
        ),
      },
      {
        Header: "مبلغ سفارش",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center success">
            <SplitNumber number={row.original.price} />
          </div>
        ),
      },
      {
        Header: "مبلغ پرداختی",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center success">
            <SplitNumber number={row.original.paymentAmountUser} />
          </div>
        ),
        Footer: (info) => {
          // Only calculate total profit if rows change
          const total = useMemo(
            () => info.rows.reduce((sum, row) => row.original.paymentAmountUser + sum, 0),
            [info.rows],
          );
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      // {
      //   Header: "مبلغ خرید",
      //   minWidth: 100,
      //   align: "center",
      //   Cell: ({ row }) => (
      //     <div className="text-center success">
      //       <SplitNumber number={row.original.paymentAmountWaranty} />
      //     </div>
      //   ),
      //   Footer: (info) => {
      //     // Only calculate total profit if rows change
      //     const total = useMemo(
      //       () => info.rows.reduce((sum, row) => row.original.paymentAmountWaranty + sum, 0),
      //       [info.rows],
      //     );
      //     return (
      //       <div className="text-center success">
      //         {" "}
      //         <SplitNumber number={total} />
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "کمیسیون پرداختی",
        minWidth: 130,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center success">
            <SplitNumber number={row.original.commisonAmount} />
          </div>
        ),
        Footer: (info) => {
          // Only calculate total profit if rows change
          const total = useMemo(
            () => info.rows.reduce((sum, row) => row.original.commisonAmount + sum, 0),
            [info.rows],
          );
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      {
        Header: "سود",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) =>
          row.original.profit < 0 ? (
            <div className="text-center text-danger">
              <ArrowDownwardIcon />
              <SplitNumber number={row.original.profit} />
            </div>
          ) : (
            <div className="text-center text-success">
              <ArrowUpwardIcon />
              <SplitNumber number={row.original.profit} />
            </div>
          ),
        Footer: (info) => {
          // Only calculate total profit if rows change
          const total = useMemo(() => info.rows.reduce((sum, row) => row.original.profit + sum, 0), [info.rows]);
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      {
        Header: "جریمه",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center success">
            <SplitNumber number={row.original.fineAmount} />
          </div>
        ),
        Footer: (info) => {
          // Only calculate total profit if rows change
          const total = useMemo(
            () => info.rows.reduce((sum, row) => row.original.fineAmount + sum, 0),
            [info.rows],
          );
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      {
        accessor: "createdPersianTime",
        Header: " زمان ایجاد",
        minWidth: "90px",
        maxWidth: "90px",
      },
    ],
    [],
  );

  const config = useMemo(() => ({
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_footer: true,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  }), []);
  return (
    <DataTable config={config} columns={columns} data={data} />
  );
}

export default DataGrid;
